import { render, staticRenderFns } from "./web-set-plan.vue?vue&type=template&id=66785e62&scoped=true&"
import script from "./web-set-plan.vue?vue&type=script&lang=js&"
export * from "./web-set-plan.vue?vue&type=script&lang=js&"
import style0 from "./web-set-plan.vue?vue&type=style&index=0&id=66785e62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66785e62",
  null
  
)

export default component.exports